import StreetAddress from 'shared/components/molecules/StreetAddress/StreetAddress';

export default StreetAddress;
